/**
 * Release 33: when the shell's install band shows (shell/PitaPasang). After sign-in only (the
 * shell), never on /periksa (another document), and only on a device not yet installed. *Tutup*
 * is remembered per device; the band comes back only if the device is still not installed 30
 * days later. It gives way to the address bands of release 26: on the old address the move
 * band says what to do first (installing there would bind the icon to the old address), and on
 * the new one the reinstall note, while it shows, already asks for the install. DOM-free.
 */
import { diAlamatLama, KUNCI_DARI_ALAMAT_LAMA, type PenyimpananAlamat } from '../alamat'
import type { SituasiPasang } from './situasi'

/** When *Tutup* was pressed on this device (ISO time). */
export const KUNCI_PASANG_DITUTUP = 'satu:pasang-ditutup'

export const JEDA_TAMPIL_LAGI_MS = 30 * 24 * 60 * 60 * 1000

export interface KeadaanPita {
  situasi: SituasiPasang
  hostname: string
  storage: PenyimpananAlamat | null
  /** Epoch ms. */
  sekarang: number
}

function baca(storage: PenyimpananAlamat | null, kunci: string): string | null {
  try {
    return storage?.getItem(kunci) ?? null
  } catch {
    return null
  }
}

export function pitaPasangTampil(k: KeadaanPita): boolean {
  if (k.situasi === 'terpasang') return false
  if (diAlamatLama(k.hostname)) return false
  if (baca(k.storage, KUNCI_DARI_ALAMAT_LAMA) !== null) return false
  const ditutup = baca(k.storage, KUNCI_PASANG_DITUTUP)
  if (ditutup === null) return true
  const pada = Date.parse(ditutup)
  // An unreadable mark counts as never pressed: better asked once more than never.
  return Number.isNaN(pada) || k.sekarang - pada >= JEDA_TAMPIL_LAGI_MS
}

/** *Tutup* (or a dismissed browser dialog): remembered on this device. */
export function tandaiDitutup(storage: PenyimpananAlamat | null, sekarang: number): void {
  try {
    storage?.setItem(KUNCI_PASANG_DITUTUP, new Date(sekarang).toISOString())
  } catch {
    // Storage refused: the band leaves for this visit and may come back on the next.
  }
}
